<template>
	<v-card class="padding elevation-0" flat>
        <v-card-text>
            <h1 class="fonte text-uppercase">Informaçoes da empresa</h1>
            <p class="black--text">Preencha o formulário abaixo e gerencie suas informaçoes pessoais</p>
            <v-divider mt-3=""></v-divider>
            <v-layout justify-space-between="" row="" wrap="" style="margin-top:50px;">
                <v-flex md5="">
                    <v-text-field ref="nome" v-model="getEmpresa.nome" :rules="[() =&gt; !!getEmpresa.nome || 'Este campo é obrigatório']" label="Nome da empresa" placeholder="Nome da empresa" color="blue-grey" required=""></v-text-field>
                </v-flex>
                <v-flex md5="">
                    <v-text-field ref="nomefantasia" :rules="[() =&gt; !!getEmpresa.nomefantasia || 'Este campo é obrigatório', () =&gt; !!getEmpresa.nomefantasia]" v-model="getEmpresa.nomefantasia" label="Nome Fantasia" placeholder="Nome Fantasia" color="blue-grey" required=""></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout justify-space-between="" row="" wrap="">
                <v-flex md5="">
                    <v-text-field ref="cnpj" :rules="[() =&gt; !!getEmpresa.cnpj || 'Este campo é obrigatório']" v-model="getEmpresa.cnpj" label="Cnpj" placeholder="Cnpj" color="blue-grey" required=""></v-text-field>
                </v-flex>
                <v-flex md5="">
                    <v-text-field ref="email" :rules="[() =&gt; /^[a-z0-9._]+@[a-z0-9]+.[a-z]+(.[a-z]+)?$/i.test(getEmpresa.email) || 'Informe um e-mail válido']" v-model="getEmpresa.email" label="E-mail" required="" placeholder="E-mail" color="blue-grey"></v-text-field>
                </v-flex>
            </v-layout>
            <v-text-field ref="telefonesadd" label="Informe o telefone e pressione enter" placeholder="Telefone" v-model="tempfone" @keyup.enter="getEmpresa.telefones.push(tempfone), tempfone=''" color="blue-grey"></v-text-field>
            <v-chip :key="i" v-for="(t, i) in getEmpresa.telefones">{{ t }}
                <v-icon @click="getEmpresa.telefones.splice(i, 1)" right="">clear</v-icon>
            </v-chip>
            <h1 class="white--text title">Endereço</h1>
            <v-layout justify-space-between="" row="" wrap="">
                <v-flex md5="">
                    <v-text-field ref="logradouro" :rules="[() =&gt; !!getEmpresa.endereco.logradouro || 'Este campo é obrigatório']" v-model="getEmpresa.endereco.logradouro" label="Logradouro" placeholder="Logradouro" color="blue-grey" required=""></v-text-field>
                </v-flex>
                <v-flex md5="">
                    <v-text-field ref="numero" :rules="[() =&gt; !!getEmpresa.endereco.numero || 'Este campo é obrigatório']" v-model="getEmpresa.endereco.numero" label="número" placeholder="número" required="" color="blue-grey"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout justify-space-between="" row="" wrap="">
                <v-flex md5="">
                    <v-text-field ref="bairro" :rules="[() =&gt; !!getEmpresa.endereco.bairro || 'Este campo é obrigatório']" v-model="getEmpresa.endereco.bairro" label="bairro" placeholder="bairro" required="" color="blue-grey"></v-text-field>
                </v-flex>
                <v-flex md5="">
                    <v-text-field ref="cidade" :rules="[() =&gt; !!getEmpresa.endereco.cidade || 'Este campo é obrigatório']" v-model="getEmpresa.endereco.cidade" label="cidade" placeholder="cidade" required="" color="blue-grey"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout justify-space-between="" row="" wrap="">
                <v-flex md5="">
                    <v-text-field ref="estado" :rules="[() =&gt; !!getEmpresa.endereco.estado || 'Este campo é obrigatório']" v-model="getEmpresa.endereco.estado" label="estado" placeholder="estado" required="" color="blue-grey"></v-text-field>
                </v-flex>
                <v-flex md5="">
                    <v-text-field @keypress="formatar('#####-###', $event)" ref="cep Ex: #####-###" :rules="[() =&gt; /^[0-9]{5}-[0-9]{3}$/.test(this.getEmpresa.endereco.cep) || 'Informe um cep válido' ]" v-model="getEmpresa.endereco.cep" label="cep" placeholder="Ex: #####-###" required="" color="blue-grey"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-divider class="mt-5"></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="white--text" color="fundo" :disabled="!validate" @click="alterar">Enviar</v-btn>
        </v-card-actions>

        <v-snackbar
        bottom
        right
        v-model="snackbar"
        color="fundo"
        >
        {{ mensagem }}
        <v-btn
            dark
            flat
            @click="snackbar = false"
        >
            <v-icon>close</v-icon>
        </v-btn>
        </v-snackbar>
    </v-card>

</template>


<script>
import axios from 'axios'
import Mask from '../../../helpers/Mask'
import getCep from '../../../helpers/GetCep'
import {mapActions, mapGetters} from 'vuex'

export default {
  mixins:[Mask],
  data(){
    return{
      tempfone:'',
      mensagem: '',
      snackbar: false,
    }
  },
  methods:{
    ...mapActions(['empresas_saveEmpresa', 'listaEmpresa', 'alteraEmpresa']),
    alterar()
    {
        this.alteraEmpresa(this.getEmpresa).then(r => {
            this.snackbar = true
            this.mensagem = r.message
        })
    },
  },
  computed:{
    ...mapGetters(['getEmpresa']),
    validate()
    {
      return !!(
        this.getEmpresa.nome && this.getEmpresa.nomefantasia && this.getEmpresa.cnpj &&
        /^[a-z0-9._]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(this.getEmpresa.email) &&
        this.getEmpresa.endereco.logradouro && this.getEmpresa.endereco.numero && this.getEmpresa.endereco.bairro &&
        this.getEmpresa.endereco.cidade && this.getEmpresa.endereco.estado && this.getEmpresa.endereco.cep
      )
    },

  },

  mounted() {
      //this.listaEmpresa()
  },
}
</script>






// WEBPACK FOOTER //
// src/components/user/empresa/DadosEmpresa.vue